
















































































import {Component, Prop} from 'vue-property-decorator';
import {ITrackingOrder} from '@/models/ITrackingOrder';
import {updateTrackingOrderToShopify} from '@/services/TrackingOrderService';
import {ModuleShop} from '@/store/modules/ShopModule';
import {LayoutModule, NotificationType} from '@/store/modules/LayoutModule';
import ChunForm from '@/mixins/ChunForm';
import {VFormData} from '@/utils/VFormData';
import {ModuleOrganization} from '@/store/modules/OrganizationModule';

interface ITrackingEditFormData {
  tracking_number: string;
  order_name: string;
  id: number;
}


@Component({})
export default class TrackingEditScreen extends ChunForm {
  @Prop() trackingOrder: ITrackingOrder;
  dialog: boolean = false;
  loading: boolean = false;

  formData: VFormData<ITrackingEditFormData> = new VFormData<ITrackingEditFormData>(
      {
        tracking_number: '',
        order_name: '',
        id: 0
      }
  );

  get shopId() {
    return ModuleShop.shopId;
  }

  onTrackingOrderChange() {
    if (this.trackingOrder) {
      this.formData.data.tracking_number = this.trackingOrder.tracking_number;
      this.formData.data.order_name = this.trackingOrder.order_name;
      this.formData.data.id = this.trackingOrder.id;
    }
  }

  get organizationId() {
    return ModuleOrganization.organizationId;
  }

  async updateTracking() {
    try {
      this.loading = true;
      const res = await updateTrackingOrderToShopify(this.organizationId, this.shopId, this.trackingOrder.id, this.formData.data.order_name, this.formData.data.tracking_number);
      if (res.status === 200) {
        LayoutModule.showNotification({text: 'Success'});
      } else {
        LayoutModule.showNotification({text: res.data.message, type: NotificationType.ERROR});
        this.dialog = true;
        return;
      }

      this.$emit('curTrackingNumber', this.formData.data.tracking_number, this.formData.data.id);
      this.dialog = false;
    } finally {
      this.loading = false;
    }
  }

  close() {
    this.dialog = false;
  }
}
